import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

// Response shape: an object keyed by eduContentTOCId whose value is the list of
// connected learningDomainIds. Empty arrays represent tocs with no connected LD.
// The requested toc is always present as a key (even when its list is empty);
// when `includeChildren` is true, descendant toc ids are also keys; when
// `includeAncestors` is true, ancestor toc ids are also keys.
export type EduContentTocLearningDomainMap = Record<number, number[]>;

export interface GetTocLearningDomainsQuery {
  eduContentTOCId: number;
  includeChildren?: boolean;
  includeAncestors?: boolean;
}

export interface GetBookLearningDomainsQuery {
  eduContentBookId: number;
}

export interface EduContentTocLearningDomainServiceInterface {
  getForToc(query: GetTocLearningDomainsQuery): Observable<EduContentTocLearningDomainMap>;
  getForBook(query: GetBookLearningDomainsQuery): Observable<EduContentTocLearningDomainMap>;
}

export const EDU_CONTENT_TOC_LEARNING_DOMAIN_SERVICE_TOKEN =
  new InjectionToken<EduContentTocLearningDomainServiceInterface>('EduContentTocLearningDomainService');
